module.exports = __webpack_public_path__ + "img/制御工学1_5.549867ca.png";